// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_b1-3";
export var contentContainer = "_b1-0";
export var editorContainer = "_b1-1";
export var quillInputForm = "_b1-2";
export var zoneDivider = "_b1-4";